import { useAuth } from "@/context/AuthContext";
import { useModulePermissions } from "@/context/ModulePermissionsContext";
import { canAccessGuardians } from "@/utils/guardiansAccess";

/** Whether the signed-in user may see Guardians UI and call guardiansv2 APIs (ops, admin, or Ani staff). */
export function useCanAccessGuardians(): boolean {
  const { hasPermission } = useModulePermissions();
  const { user } = useAuth();
  return canAccessGuardians(hasPermission, user);
}
